export default function Loading () {
  return (
    <div className="loading">
      <div className="spinner"></div>
      <p>Carregando conteúdo...</p>
    </div>
  );
};